// Bridges the service worker registration (set up in index.tsx before React
// mounts) to the UI, holding the value so a late subscriber still receives it.

type Listener = (registration: ServiceWorkerRegistration) => void;

let waitingRegistration: ServiceWorkerRegistration | null = null;
const listeners = new Set<Listener>();

export function publishServiceWorkerUpdate(registration: ServiceWorkerRegistration) {
  waitingRegistration = registration;
  listeners.forEach((l) => l(registration));
}

export function onServiceWorkerUpdate(listener: Listener) {
  listeners.add(listener);
  if (waitingRegistration) listener(waitingRegistration);
  return () => {
    listeners.delete(listener);
  };
}
